// Welcome screen - первый экран приложения
import { SocialAuthButtons } from '@/features/auth/social';
import { useRouterNavigation } from '@/lib';
import { useTranslation } from 'react-i18next';
import { PageFooter } from '@/components';
import { Button } from '@/components/ui/button';

/**
 * Страница приветствия для неавторизованных пользователей
 */
export function WelcomePage(): JSX.Element {
  const { t } = useTranslation();
  const { toSignUp, toSignIn } = useRouterNavigation();

  const handleSignUp = () => {
    toSignUp();
  };

  const handleSignIn = () => {
    toSignIn();
  };

  return (
    <div className="flex flex-col h-screen bg-background">
      {/* Верхняя часть — место для иллюстрации */}
      <div className="flex-1 pt-14" />

      {/* Нижняя часть — текст + кнопки, сгруппированы вместе */}
      <PageFooter>
        {/* Заголовок */}
        <h1 className="text-2xl font-semibold text-center mb-2">
          Toive
        </h1>

        {/* Описание */}
        <p className="text-base font-normal text-muted-foreground text-center mb-8">
          {t('auth:auth.welcomeDescription')}
        </p>

        {/* Primary CTA */}
        <Button
          onClick={handleSignUp}
          className="w-full"
        >
          {t('auth:auth.signUp')}
        </Button>

        {/* Secondary CTA */}
        <Button
          variant="outline"
          onClick={handleSignIn}
          className="w-full mt-2.5"
        >
          {t('auth:auth.signIn')}
        </Button>

        {/* Divider */}
        <div className="flex items-center gap-4 my-6">
          <div className="flex-1 h-px bg-primary-light" />
          <span className="text-sm font-normal text-muted-foreground">
            {t('auth:auth.orContinueWith')}
          </span>
          <div className="flex-1 h-px bg-primary-light" />
        </div>

        {/* Social Auth */}
        <SocialAuthButtons />
      </PageFooter>
    </div>
  );
}